export const MULTI_EDIT_SEGMENTS = ['expi', 'package'];
